function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

class SectionId {
  static #separator = '__';

  // for a qualified section id (e.g. 'template--22224696705326__main'), return just the section id (e.g. 'template--22224696705326')
  static parseId(qualifiedSectionId) {
    return qualifiedSectionId.split(SectionId.#separator)[0];
  }

  // for a qualified section id (e.g. 'template--22224696705326__main'), return just the section name (e.g. 'main')
  static parseSectionName(qualifiedSectionId) {
    return qualifiedSectionId.split(SectionId.#separator)[1];
  }

  // for a section id (e.g. 'template--22224696705326') and a section name (e.g. 'recommended-products'), return a qualified section id (e.g. 'template--22224696705326__recommended-products')
  static getIdForSection(sectionId, sectionName) {
    return `${sectionId}${SectionId.#separator}${sectionName}`;
  }
}

class HTMLUpdateUtility {
  /**
   * Used to swap an HTML node with a new node.
   * The new node is inserted as a previous sibling to the old node, the old node is hidden, and then the old node is removed.
   *
   * The function currently uses a double buffer approach, but this should be replaced by a view transition once it is more widely supported https://developer.mozilla.org/en-US/docs/Web/API/View_Transitions_API
   */
  static viewTransition(oldNode, newContent, preProcessCallbacks = [], postProcessCallbacks = []) {
    preProcessCallbacks?.forEach((callback) => callback(newContent));

    const newNodeWrapper = document.createElement('div');
    HTMLUpdateUtility.setInnerHTML(newNodeWrapper, newContent.outerHTML);
    const newNode = newNodeWrapper.firstChild;

    // dedupe IDs
    const uniqueKey = Date.now();
    oldNode.querySelectorAll('[id], [form]').forEach((element) => {
      element.id && (element.id = `${element.id}-${uniqueKey}`);
      element.form && element.setAttribute('form', `${element.form.getAttribute('id')}-${uniqueKey}`);
    });

    oldNode.parentNode.insertBefore(newNode, oldNode);
    oldNode.style.display = 'none';

    postProcessCallbacks?.forEach((callback) => callback(newNode));

    setTimeout(() => oldNode.remove(), 500);
  }

  // Sets inner HTML and reinjects the script tags to allow execution. By default, scripts are disabled when using element.innerHTML.
  static setInnerHTML(element, html) {
    element.innerHTML = html;
    element.querySelectorAll('script').forEach((oldScriptTag) => {
      const newScriptTag = document.createElement('script');
      Array.from(oldScriptTag.attributes).forEach((attribute) => {
        newScriptTag.setAttribute(attribute.name, attribute.value);
      });
      newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
      oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
    });
  }
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));
  
  if (summary.nextElementSibling && summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer, menu-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

document.querySelectorAll('details.mega-menu').forEach((detailsEl) => {
  const parentEl = detailsEl.closest('.header');
  const stickyParentEl = parentEl?.parentElement;
  const promoBarEls = document.querySelectorAll('.announcement-bar-section, .utility-bar--announcement');

  if (!parentEl) return;

  detailsEl.addEventListener('mouseenter', () => {
    parentEl.classList.add('hover--megamenu');
    if (stickyParentEl) {
      stickyParentEl.classList.add('hover--megamenu');
    }

    if (promoBarEls.length) {
      promoBarEls.forEach((el) => {
        el.classList.add('hover--megamenu');
      });
    }
  });

  detailsEl.addEventListener('mouseleave', () => {
    parentEl.classList.remove('hover--megamenu');

    if (stickyParentEl) {
      stickyParentEl.classList.remove('hover--megamenu');
    }

    if (promoBarEls.length) {
      promoBarEls.forEach((el) => {
        el.classList.remove('hover--megamenu');
      });
    }
  });
});

const loyaltyAccountLink = document.querySelector('.loyalty-wrapper .loyalty-sign-in-link.header__icon--account');
const loyaltyAccountMenu = document.querySelector('.loyalty-wrapper .account-nav-menu');

let hideAccountMenuTimeout;

function showAccountMenu() {
  clearTimeout(hideAccountMenuTimeout);
  loyaltyAccountMenu?.classList.add('account-menu--visible');
}

function hideAccountMenu() {
  hideAccountMenuTimeout = setTimeout(() => {
    loyaltyAccountMenu?.classList.remove('account-menu--visible');
  }, 300);
}

loyaltyAccountLink?.addEventListener('mouseenter', showAccountMenu);
loyaltyAccountLink?.addEventListener('mouseleave', hideAccountMenu);
loyaltyAccountMenu?.addEventListener('mouseenter', showAccountMenu);
loyaltyAccountMenu?.addEventListener('mouseleave', hideAccountMenu);
loyaltyAccountLink?.addEventListener('focus', showAccountMenu);
loyaltyAccountLink?.addEventListener('blur', hideAccountMenu);

loyaltyAccountMenu?.addEventListener('focusin', showAccountMenu);
loyaltyAccountMenu?.addEventListener('focusout', (event) => {
  hideAccountMenuTimeout = setTimeout(() => {
    if (!loyaltyAccountMenu.contains(document.activeElement)) {
      loyaltyAccountMenu?.classList.remove('account-menu--visible');
    }
  }, 300);
});

window.addEventListener('DOMContentLoaded', function() {
  let loyaltyWrapper = document.querySelector('.loyalty-wrapper');

  if (loyaltyWrapper) {
    loyaltyWrapper.querySelector('.is-customer')?.addEventListener('click', function() { window.location.href = window.routes.account_url;
    })
  }
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (event.target !== container && event.target !== last && event.target !== first) return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if ((event.target === container || event.target === first) && event.shiftKey) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (
    elementToFocus.tagName === 'INPUT' &&
    ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
    elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(':focus-visible');
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    'ARROWUP',
    'ARROWDOWN',
    'ARROWLEFT',
    'ARROWRIGHT',
    'TAB',
    'ENTER',
    'SPACE',
    'ESCAPE',
    'HOME',
    'END',
    'PAGEUP',
    'PAGEDOWN',
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    'focus',
    () => {
      if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add('focused');
    },
    true
  );
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function closeAllModalDialogs() {
  document.querySelectorAll('modal-dialog').forEach((modalDialog) => {if(modalDialog.hasAttribute('open') && modalDialog.hide){modalDialog.hide()}});
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });
    this.input.addEventListener('change', this.onInputChange.bind(this));
    this.querySelectorAll('button').forEach((button) =>
      button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.validateQtyRules.bind(this));
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    this.validateQtyRules();
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    if (event.target.name === 'plus') {
      if (parseInt(this.input.dataset.min) > parseInt(this.input.step) && this.input.value == 0) {
        this.input.value = this.input.dataset.min;
      } else {
        this.input.stepUp();
      }
    } else {
      this.input.stepDown();
    }

    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);

    if (this.input.dataset.min === previousValue && event.target.name === 'minus') {
      this.input.value = parseInt(this.input.min);
    }
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      buttonMinus.classList.toggle('disabled', parseInt(value) <= parseInt(this.input.min));
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle('disabled', value >= max);
    }
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function throttle(fn, delay) {
  let lastCall = 0;
  return function (...args) {
    const now = new Date().getTime();
    if (now - lastCall < delay) {
      return;
    }
    lastCall = now;
    return fn(...args);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: `application/${type}` },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement('form');
  form.setAttribute('method', method);
  form.setAttribute('action', path);

  for (var key in params) {
    var hiddenField = document.createElement('input');
    hiddenField.setAttribute('type', 'hidden');
    hiddenField.setAttribute('name', key);
    hiddenField.setAttribute('value', params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = '';
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach((summary) =>
      summary.addEventListener('click', this.onSummaryClick.bind(this))
    );
    this.querySelectorAll(
      'button:not(.localization-selector):not(.country-selector__close-button):not(.country-filter__reset-button)'
    ).forEach((button) => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary'))
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);

      if (window.matchMedia('(max-width: 990px)')) {
        document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach((details) => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach((submenu) => {
      submenu.classList.remove('submenu-open');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);

    if (event instanceof KeyboardEvent) elementToFocus?.setAttribute('aria-expanded', false);
  }

  onFocusOut() {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement))
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.querySelector('.section-header');
    this.borderOffset =
      this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty(
      '--header-bottom-position',
      `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
    );
    this.header.classList.add('menu-open');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    window.addEventListener('resize', this.onResize);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    if (!elementToFocus) return;
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
    window.removeEventListener('resize', this.onResize);
  }

  onResize = () => {
    this.header &&
      document.documentElement.style.setProperty(
        '--header-bottom-position',
        `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
      );
    document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
  };
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
     this.lineItemSrc = null;
    this.querySelector('[id^="ModalClose-"]').addEventListener('click', this.hide.bind(this, false));
    this.addEventListener('keyup', (event) => {
      if (event.code?.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this && !event.target.classList.contains('vto-window')) { // do not close VTO modal on background click, VTO user must click X button to exit VTO
          this.hide();
        }

      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    this.dataset.section = this.closest('.shopify-section')?.id.replace('shopify-section-', '');
    document.body.appendChild(this);
  }

  show(opener) {
    window.closeAllModalDialogs();
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    const scrollY = window._savedScrollPosition || window.scrollY;
    document.body.classList.add('overflow-hidden');

    requestAnimationFrame(() => {
      window.scrollTo(0, scrollY);
    });

    this.setAttribute('open', '');
    this.setAttribute('aria-hidden', 'false');
    if (popup) popup.loadContent();
    setTimeout(() => {
    trapFocus(this, this.querySelector('[role="dialog"]'));
    }, 300);
    window.pauseAllMedia();
  }

  hide() {
    window.isFromQv = false;
    window.isFromQvCart = false;
    window.isFromPDP = false;
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed', {detail: this.id}));
    this.removeAttribute('open');
    this.setAttribute('aria-hidden', 'true');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
    const qvModal = document.querySelector('#Quickshop-Modal');
    if(window.isFromQv && qvModal) {
      window.isFromQv = false;
      qvModal.show();
    }
  }
}
customElements.define('modal-dialog', ModalDialog);

class FetchModalDialog extends ModalDialog {
  constructor() {
    super();
  }

  connectedCallback() {
    if (window.Shopify && window.Shopify.designMode) {
      super.show()
    }
  }

  show(opener) {
    super.show(opener)
  }

  hide() {
    super.hide();
  }
}
customElements.define('fetch-modal-dialog', FetchModalDialog);

class BulkModal extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);
      if (this.innerHTML.trim() === '') {
        const productUrl = this.dataset.url.split('?')[0];
        fetch(`${productUrl}?section_id=bulk-quick-order-list`)
          .then((response) => response.text())
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            const sourceQty = html.querySelector('.quick-order-list-container').parentNode;
            this.innerHTML = sourceQty.innerHTML;
          })
          .catch((e) => {
            console.error(e);
          });
      }
    };

    new IntersectionObserver(handleIntersection.bind(this)).observe(
      document.querySelector(`#QuickBulk-${this.dataset.productId}-${this.dataset.sectionId}`)
    );
  }
}

customElements.define('bulk-modal', BulkModal);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const openedFromQuickshop = !!button.closest('#Quickshop-Modal');
      const openedFromQuickshopCart = !!button.closest('#Quickshop-Modal-cart');
      const openedFromBuildkitQuickshop = !!button.closest('#Buildkit-Quickshop-Modal');
      const modalSelector = this.getAttribute('data-modal') || '';
      const openedShadeListFromQuickshop = openedFromQuickshop && modalSelector.startsWith('#ShadeList-Modal');

      if (openedShadeListFromQuickshop) {
        // Keep quickshop content intact while shade list temporarily steals focus
        window.skipQuickshopReset = true;
      }

      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
      if (openedFromQuickshop) {
        window.isFromQv = true;
        window.isFromQvCart = false;
        window.isFromPDP = false;
        window.isFromQvBuildkit = false;
      } else if (openedFromQuickshopCart) {
        window.isFromQvCart = true;
        window.isFromQv = false;
        window.isFromPDP = false;
        window.isFromQvBuildkit = false;
      } else if (openedFromBuildkitQuickshop) {
        window.isFromQvCart = false;
        window.isFromQv = false;
        window.isFromPDP = false;
        window.isFromQvBuildkit = true;
      } else {
        window.isFromPDP = true;
        window.isFromQv = false;
        window.isFromQvCart = false;
        window.isFromQvBuildkit = false;
      }
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class FetchModalOpener extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.backButtonContext = null;
    const button = this.querySelector('button');
    if (!button) return;

    button.addEventListener('click', () => { 
      const modalID = this.getAttribute('data-modal');
      const url = this.getAttribute('data-url');
      const backButtonContext = button.getAttribute('data-back-button-context');
      if (backButtonContext) {
        this.backButtonContext = this.closest('#findMyShadeModal').querySelector(backButtonContext); // button.closest(backButtonContext);
        button.removeAttribute('data-back-button-context');
      }
      if(button.closest('#Quickshop-Modal')) {
        window.isFromQv = true;
      }
      this.renderModal(url, modalID);
    });
  }

  renderModal(url, modalID) {
    let modalDialog;
    let modal = document.querySelector(modalID);
    if(modal && modal.parentNode) {
      modal.parentNode.removeChild(modal);
    }
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        modalDialog = html.querySelector(modalID);
        const modalScripts = modalDialog.querySelectorAll('script');
        if (modalScripts.length) {
          modalScripts.forEach(script => {
            const newScript = document.createElement('script');
            if (script.src) {
              newScript.src = script.src;
            } else {
              newScript.textContent = script.textContent;
            }
            document.body.appendChild(newScript);
          });
        }

        document.body.appendChild(modalDialog);
        
      })
      .then(() => {
        if (this.backButtonContext) {
          modalDialog.show(this.backButtonContext);
          this.backButtonContext;
        } else {
          modalDialog.show(this);
        }
      })
      .catch((error) => {
        console.error(error);
      });
  }
}
customElements.define('fetch-modal-opener', FetchModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
      if (deferredElement.nodeName == 'VIDEO' && deferredElement.getAttribute('autoplay')) {
        // force autoplay for safari
        deferredElement.play();
      }
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter((element) => element.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor(
      (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset
    );
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    // Temporarily prevents unneeded updates resulting from variant changes
    // This should be refactored as part of https://github.com/Shopify/dawn/issues/2057
    if (!this.slider || !this.nextButton) return;

    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent('slideChanged', {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1],
          },
        })
      );
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return element.offsetLeft + element.clientWidth <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition =
      event.currentTarget.name === 'next'
        ? this.slider.scrollLeft + step * this.sliderItemOffset
        : this.slider.scrollLeft - step * this.sliderItemOffset;
    this.setSlidePosition(this.slideScrollPosition);
  }

  setSlidePosition(position) {
    this.slider.scrollTo({
      left: position,
    });
  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.announcementBarSlider = this.querySelector('.announcement-bar-slider');
    // Value below should match --duration-announcement-bar CSS value
    this.announcerBarAnimationDelay = this.announcementBarSlider ? 250 : 0;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach((link) => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.announcementBarSlider) {
      this.announcementBarArrowButtonWasClicked = false;

      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.reducedMotion.addEventListener('change', () => {
        if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
      });

      [this.prevButton, this.nextButton].forEach((button) => {
        button.addEventListener(
          'click',
          () => {
            this.announcementBarArrowButtonWasClicked = true;
          },
          { once: true }
        );
      });
    }

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  setAutoPlay() {
    this.autoplaySpeed = this.slider.dataset.speed * 1000;
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    if (this.querySelector('.slideshow__autoplay')) {
      this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
      this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
      this.autoplayButtonIsSetToPlay = true;
      this.play();
    } else {
      this.reducedMotion.matches || this.announcementBarArrowButtonWasClicked ? this.pause() : this.play();
    }
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    this.wasClicked = true;

    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) {
      this.applyAnimationToAnnouncementBar(event.currentTarget.name);
      return;
    }

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition =
        this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }

    this.setSlidePosition(this.slideScrollPosition);

    this.applyAnimationToAnnouncementBar(event.currentTarget.name);
  }

  setSlidePosition(position) {
    if (this.setPositionTimeout) clearTimeout(this.setPositionTimeout);
    this.setPositionTimeout = setTimeout(() => {
      this.slider.scrollTo({
        left: position,
      });
    }, this.announcerBarAnimationDelay);
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach((link) => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
      this.play();
    } else if (!this.reducedMotion.matches && !this.announcementBarArrowButtonWasClicked) {
      this.play();
    }
  }

  focusInHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
        this.play();
      } else if (this.autoplayButtonIsSetToPlay) {
        this.pause();
      }
    } else if (this.announcementBarSlider.contains(event.target)) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition =
      this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.sliderItemOffset;

    this.setSlidePosition(slideScrollPosition);
    this.applyAnimationToAnnouncementBar();
  }

  setSlideVisibility(event) {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll('a');
      if (index === this.currentPage - 1) {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.removeAttribute('tabindex');
          });
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.setAttribute('tabindex', '-1');
          });
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
    this.wasClicked = false;
  }

  applyAnimationToAnnouncementBar(button = 'next') {
    if (!this.announcementBarSlider || !this.sliderItems?.length) return;

    const itemsCount = this.sliderItems.length;
    const increment = button === 'next' ? 1 : -1;

    const currentIndex = this.currentPage - 1;
    let nextIndex = (currentIndex + increment) % itemsCount;
    nextIndex = nextIndex === -1 ? itemsCount - 1 : nextIndex;

    const nextSlide = this.sliderItems[nextIndex];
    const currentSlide = this.sliderItems[currentIndex];

    const animationClassIn = 'announcement-bar-slider--fade-in';
    const animationClassOut = 'announcement-bar-slider--fade-out';

    const isFirstSlide = currentIndex === 0;
    const isLastSlide = currentIndex === itemsCount - 1;

    const shouldMoveNext = (button === 'next' && !isLastSlide) || (button === 'previous' && isFirstSlide);
    const direction = shouldMoveNext ? 'next' : 'previous';

    setTimeout(() => {
      if (currentSlide && nextSlide) {
        currentSlide.classList.remove(`${animationClassOut}-${direction}`);
        nextSlide.classList.remove(`${animationClassIn}-${direction}`);
      }
    }, this.announcerBarAnimationDelay * 2);
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition =
      this.slider.scrollLeft +
      this.sliderFirstItemNode.clientWidth *
        (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.pickerType = this.dataset?.pickerType;
    this.updateBundleImageDesc();
    this.selectedOptionsMap = new Map();
  }

  connectedCallback() {
    this.addEventListener('change', (event) => {
      const target = this.getInputForEventTarget(event.target);
      this.updateSelectionMetadata(event);
      this.updateBundleImageDesc();
      this.updateRecommendedProductsCTA(target);

      publish(PUB_SUB_EVENTS.optionValueSelectionChange, {
        data: {
          event,
          target,
          selectedOptionValues: this.selectedOptionValues,
          selectedVariantInventory: this.selectedVariantInventory,
          selectedVariantDiscontinued: this.selectedVariantDiscontinued
        },
      });
    });

    if (this.pickerType === 'upsell-variant-picker') {
      this.addEventListener('change', (event) => {
        const target = this.getInputForEventTarget(event.target);
        this.updateUpsellDesc(target);
        this.updateUpsellCTA(target);
        this.updateUpsellImage(target);
      });
    }

    const autoChecked = this.querySelector('input[type=radio]:checked') || this.querySelector('input[data-initially-checked="true"]');
    if (autoChecked) {
      const optionName = autoChecked.name;
      const valueId = autoChecked.dataset.optionValueId;
      if (optionName && valueId) {
        this.selectedOptionsMap.set(optionName, valueId);
      }
    }

    if (this.pickerType === 'bag-special-variant-picker') {
      this.ensureInputSelected();
    }
  }

  updateBundleImageDesc(target = null) {
    let inputs = [];
  
    if (target) {
      inputs = [target];
    } else {
      inputs = document.querySelectorAll('.bundle-variant-selects .shade-input:checked');
    }
  
    inputs.forEach(input => {
      const wrapper = input.closest('.bundle-product-container');
      if (!wrapper) return;
  
      const mainImageSelector = `#${input.getAttribute('data-main-image')}`;
      const shadeDescSelector = `#${input.getAttribute('data-short-desc')}`;
      const newImageUrl = input.getAttribute('data-variant-image');
      const newShadeDesc = input.getAttribute('data-variant-desc');
      const unavailableMessage = input.getAttribute('data-unavailable-message');
      let newShadeValue = input.getAttribute('value');

      const mainImages = wrapper.querySelectorAll(mainImageSelector);
      const shadeDescs = wrapper.querySelectorAll(shadeDescSelector);
      const shadeValueContainer = wrapper.querySelector('.product-form__shade-value');

      if (unavailableMessage) {
        shadeValueContainer?.classList?.add('has-oos-msg');
        newShadeValue = '<span class="shade-value--bundle">' + newShadeValue + '</span> <span class="shade-value--not-available">' + unavailableMessage;
      } else {
        shadeValueContainer?.classList?.remove('has-oos-msg');
        newShadeValue = '<span class="shade-value--bundle">' + newShadeValue;
      }

      if (newImageUrl && mainImages.length) {
        mainImages.forEach(mainImage => {
          mainImage.src = newImageUrl;
        });
      }

      if (newShadeValue && shadeValueContainer) {
        shadeValueContainer.innerHTML = newShadeValue + ' <span class="product-shade-icon--angle-down"><i class="fa-light fa-angle-down"></i></span>';
      }

      if (newShadeDesc && shadeDescs.length) {
        shadeDescs.forEach(shadeDesc => {
          shadeDesc.innerHTML = newShadeDesc;
        });
      }
    });
  }

  updateUpsellCTA(target) {
    if (target.getAttribute('name') !== 'upsell-swatch') {
      return;
    }
    let upsellAvailable = target.getAttribute('data-variant-available');
    let upsellCTA = document.querySelector('.cta-button.primary.upsell');
    let pairWithCTA = document.querySelector('.cta-button.primary.pair-with-section');

    if (upsellAvailable && upsellCTA) {
      if (upsellAvailable == 'false') {
        upsellCTA.innerHTML = window.variantStrings.joinTheWaitlist;
      } else if (pairWithCTA) {
        pairWithCTA.innerHTML = window.variantStrings.addProduct;
      } else {
        upsellCTA.innerHTML = window.variantStrings.addToCart;
      }
    }
  }

  updateUpsellDesc(target) {
    const variantDesc = document.querySelector('.upsell-picker.product-form__shade-description');
    let newShadeDesc = target.getAttribute('data-variant-desc');

    if (newShadeDesc && variantDesc) {
      variantDesc.innerHTML = newShadeDesc;
    } else if(!newShadeDesc && variantDesc) {
      variantDesc.innerHTML = '';
    }
  }

  updateUpsellImage(target) {
    const parentContainer = this.closest('.product__upsell');
    const variantImg = parentContainer?.querySelector('.product__upsell-image img');
    let newVariantImgSrc = target.getAttribute('data-variant-image');

    if (variantImg && newVariantImgSrc) {
      variantImg.src = newVariantImgSrc;
      variantImg.srcset = newVariantImgSrc;
    }
  }

  updateSelectionMetadata({ target }) {
    const { value, tagName } = target;

    const optionName = target.name;
    const valueId = target.dataset.optionValueId;

    if (optionName && valueId) {
      this.selectedOptionsMap.set(optionName, valueId);
    }

    if (tagName === 'SELECT' && target.selectedOptions.length) {
      Array.from(target.options)
        .find((option) => option.getAttribute('selected'))
        .removeAttribute('selected');
      target.selectedOptions[0].setAttribute('selected', 'selected');

      const swatchValue = target.selectedOptions[0].dataset.optionSwatchValue;
      const selectedDropdownSwatchValue = target
        .closest('.product-form__input')
        .querySelector('[data-selected-value] > .swatch');
      if (!selectedDropdownSwatchValue) return;
      if (swatchValue) {
        selectedDropdownSwatchValue.style.setProperty('--swatch--background', swatchValue);
        selectedDropdownSwatchValue.classList.remove('swatch--unavailable');
      } else {
        selectedDropdownSwatchValue.style.setProperty('--swatch--background', 'unset');
        selectedDropdownSwatchValue.classList.add('swatch--unavailable');
      }

      selectedDropdownSwatchValue.style.setProperty(
        '--swatch-focal-point',
        target.selectedOptions[0].dataset.optionSwatchFocalPoint || 'unset'
      );
    } else if (tagName === 'INPUT' && target.type === 'radio') {
      const swatchDescriptionValue = target.dataset.variantDesc;
      const selectedSwatchValue = target.closest(`.product-form__input`).querySelector('[data-selected-value] .shade-value-inner');
      const selectedSwatchDescription = target.closest(`.product-form__input`).querySelector('.product-form__shade-description');
      if (selectedSwatchValue) selectedSwatchValue.innerHTML = value;
      if (selectedSwatchDescription && swatchDescriptionValue) {
        selectedSwatchDescription.innerHTML = swatchDescriptionValue;
      } else if (!swatchDescriptionValue && selectedSwatchDescription) {
        selectedSwatchDescription.innerHTML = '';
      }
    }
  }

  updateRecommendedProductsCTA(target) {
    if (!target.classList.contains('bag-special-swatch-input')) {
      return;
    }
    const variantId = target.dataset.variantId;
    const available = target.dataset.variantAvailable;
    const atb = target.closest('.recommended-selector-container').querySelector('.recommended-cta-button');

    if (variantId && available && atb) {  
      atb.dataset.variantId = variantId;
      atb.disabled = available === 'false';
    }
  }

  getInputForEventTarget(target) {
    return target.tagName === 'SELECT' ? target.selectedOptions[0] : target;
  }

  // usable in this component and useful in Swiper initialization callbacks 
  // returns default input
  clickDefaultSelectedShadeInput() {
    const defaultSelectedShadeInput = this.querySelector('.swatch-input__input[data-is-default-selected-shade="true"]');
    if (defaultSelectedShadeInput) {
      defaultSelectedShadeInput.click();
    }
    return defaultSelectedShadeInput;
  }

  // usable in this component and useful in Swiper initialization callbacks 
  goToDefaultSlide() {
    const defaultSelectedShadeInput = this.querySelector('.swatch-input__input[data-is-default-selected-shade="true"]');
    const swiperSlide = defaultSelectedShadeInput?.closest('.swiper-slide');
    if (swiperSlide) {
      const swiperEl = swiperSlide.closest('.swiper-initialized');
      if (swiperEl?.swiper) {
        const index = Array.from(swiperEl.querySelectorAll('.swiper-slide')).indexOf(swiperSlide);
        swiperEl.swiper.slideTo(index, 0);
      }
    }
  }

  goToSelectedSlide() {
    const defaultSelectedShadeInput = this.querySelector('.swatch-input__input:checked');
    const swiperSlide = defaultSelectedShadeInput?.closest('.swiper-slide');
    if (swiperSlide) {
      const swiperEl = swiperSlide.closest('.swiper-initialized');
      if (swiperEl?.swiper) {
        const index = Array.from(swiperEl.querySelectorAll('.swiper-slide')).indexOf(swiperSlide);
        swiperEl.swiper.slideTo(index, 0);
      }
    }
  }

  ensureInputSelected() {
    if (this.selectedOptionsMap) {
      this.selectedOptionsMap.forEach(selectedOption => {
        const input = this.querySelector(`input[type=radio][data-option-value-id="${selectedOption}"]`);
        input.click();
      });
    }
  }

  get selectedOptionValues() {
    return Array.from(
      this.querySelectorAll('fieldset input[type="radio"]:checked')
    ).map(input => input.dataset.optionValueId);
  }

  get selectedVariantInventory() {
    return Array.from(this.querySelectorAll('.non-bundle-input:checked, fieldset input:checked')).map(
      ({ dataset }) => dataset.variantAvailable
    );
  }

  get selectedVariantDiscontinued() {
    return Array.from(this.querySelectorAll('.non-bundle-input:checked, fieldset input:checked')).map(
      ({ dataset }) => dataset.variantDiscontinued
    );
  }
}

customElements.define('variant-selects', VariantSelects);

class ProductRecommendations extends HTMLElement {
  observer = undefined;

  constructor() {
    super();
  }

  connectedCallback() {
    this.initializeRecommendations(this.dataset.productId);
  }

  initializeRecommendations(productId) {
    this.observer?.unobserve(this);
    this.observer = new IntersectionObserver(
      (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);
        this.loadRecommendations(productId);
      },
      { rootMargin: '0px 0px 400px 0px' }
    );
    this.observer.observe(this);
  }

  loadRecommendations(productId) {
    fetch(`${this.dataset.url}&product_id=${productId}&section_id=${this.dataset.sectionId}`)
      .then((response) => response.text())
      .then((text) => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('product-recommendations');

        if (recommendations?.innerHTML.trim().length) {
          this.innerHTML = recommendations.innerHTML;
        }

        if (!this.querySelector('slideshow-component') && this.classList.contains('complementary-products')) {
          this.remove();
        }

        if (html.querySelector('.grid__item')) {
          this.classList.add('product-recommendations--loaded');
        }
      })
      .catch((e) => {
        console.error(e);
      });
  }
}

customElements.define('product-recommendations', ProductRecommendations);

class AccountIcon extends HTMLElement {
  constructor() {
    super();

    this.icon = this.querySelector('.icon');
  }

  connectedCallback() {
    document.addEventListener('storefront:signincompleted', this.handleStorefrontSignInCompleted.bind(this));
  }

  handleStorefrontSignInCompleted(event) {
    if (event?.detail?.avatar) {
      this.icon?.replaceWith(event.detail.avatar.cloneNode());
    }
  }
}

customElements.define('account-icon', AccountIcon);

class BulkAdd extends HTMLElement {
  constructor() {
    super();
    this.queue = [];
    this.requestStarted = false;
    this.ids = [];
  }

  startQueue(id, quantity) {
    this.queue.push({ id, quantity });
    const interval = setInterval(() => {
      if (this.queue.length > 0) {
        if (!this.requestStarted) {
          this.sendRequest(this.queue);
        }
      } else {
        clearInterval(interval);
      }
    }, 250);
  }

  sendRequest(queue) {
    this.requestStarted = true;
    const items = {};
    queue.forEach((queueItem) => {
      items[parseInt(queueItem.id)] = queueItem.quantity;
    });
    this.queue = this.queue.filter((queueElement) => !queue.includes(queueElement));
    const quickBulkElement = this.closest('quick-order-list') || this.closest('quick-add-bulk');
    quickBulkElement.updateMultipleQty(items);
  }

  resetQuantityInput(id) {
    const input = this.querySelector(`#Quantity-${id}`);
    input.value = input.getAttribute('value');
    this.isEnterPressed = false;
  }

  setValidity(event, index, message) {
    event.target.setCustomValidity(message);
    event.target.reportValidity();
    this.resetQuantityInput(index);
    event.target.select();
  }

  validateQuantity(event) {
    const inputValue = parseInt(event.target.value);
    const index = event.target.dataset.index;

    if (inputValue < event.target.dataset.min) {
      this.setValidity(event, index, window.quickOrderListStrings.min_error.replace('[min]', event.target.dataset.min));
    } else if (inputValue > parseInt(event.target.max)) {
      this.setValidity(event, index, window.quickOrderListStrings.max_error.replace('[max]', event.target.max));
    } else if (inputValue % parseInt(event.target.step) != 0) {
      this.setValidity(event, index, window.quickOrderListStrings.step_error.replace('[step]', event.target.step));
    } else {
      event.target.setCustomValidity('');
      event.target.reportValidity();
      this.startQueue(index, inputValue);
    }
  }

  getSectionsUrl() {
    if (window.pageNumber) {
      return `${window.location.pathname}?page=${window.pageNumber}`;
    } else {
      return `${window.location.pathname}`;
    }
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }
}

if (!customElements.get('bulk-add')) {
  customElements.define('bulk-add', BulkAdd);
}

function getCountryFromLocale() {
  if (window.Shopify && typeof window.Shopify.country === 'string') {
    return window.Shopify.country.toUpperCase();
  }
  return 'US'; // default fallback
}

function formatCurrencyAmount(amount, country = 'US') {
  const roundedAmount = Math.round(amount * 100) / 100;
  
  if (country === 'US') {
    // US formatting rules
    if (roundedAmount % 1 === 0) {
      // No decimal points if it ends in .00
      return roundedAmount.toString();
    } else {
      // 2 decimal places for US
      return roundedAmount.toFixed(2);
    }
  } else {
    if (roundedAmount % 1 === 0) {
      return roundedAmount.toString();
    } else {
      // Default to 2 decimal places
      return roundedAmount.toFixed(2);
    }
  }
}

function togglePromotionProgressBar(els, show = true, transition = false, delay = '0s') {
  els.forEach(el => {
    el.style.opacity = show ? '1' : '0';
    el.style.display = show ? 'block' : 'none';
    if (transition) {
      el.style.transition = 'opacity 1s ease-in-out';
      el.style.transitionDelay = delay;
    }
  });
}

function formatCurrencyWithAmount(amount) {
  const locale = window.Shopify && window.Shopify.locale ? window.Shopify.locale : 'en';
  const currency =
    (window.Shopify && Shopify.currency && Shopify.currency.active) ||
      document.documentElement.getAttribute('data-shopify-currency') ||
      'USD';
  const numericAmount = Number(amount || 0);

  try {
   const formatter = new Intl.NumberFormat(locale, {
      style: 'currency',
      currency: currency,
      currencyDisplay: 'narrowSymbol'
    });

    const { maximumFractionDigits } = formatter.resolvedOptions();
    const hasCents =
      maximumFractionDigits > 0 &&
      numericAmount % 1 !== 0;

    const localizedAmount = new Intl.NumberFormat(locale, {
      style: 'currency',
      currency: currency,
      currencyDisplay: 'narrowSymbol',
      minimumFractionDigits: hasCents ? maximumFractionDigits : 0,
      maximumFractionDigits
    }).format(numericAmount);

    return localizedAmount;
  } catch (e) {
    return `${currency}${numericAmount}`;
  }
}

function handleFreeShippingPromotion(subtotalClean, country) {
  const shippingEl = document.querySelector('.cart-notification-promotion-free-shipping');
  if (!shippingEl) return false;

  const threshold = parseFloat(document.getElementById('free-shipping-threshold')?.dataset?.freeShippingThreshold || 0);
  const remaining = Math.max(threshold - subtotalClean, 0);
  const percent = (subtotalClean / threshold) * 100;

  shippingEl.querySelectorAll('.free-shipping-percentage').forEach(el => el.style.width = `${percent}%`);

  const formattedRemaining = formatCurrencyAmount(remaining, country);
  const formattedRemainingWithCurrency = formatCurrencyWithAmount(formattedRemaining);

  shippingEl.querySelectorAll('.free-shipping-spend-more').forEach(el => el.textContent = formattedRemainingWithCurrency);

  const notQualifiedEls = shippingEl.querySelectorAll('.not-qualified');
  const qualifiedEls = shippingEl.querySelectorAll('.qualified');
  const progressBarEls = shippingEl.querySelectorAll('.free-shipping-progress-bar');

  if (percent < 100) {
    togglePromotionProgressBar(progressBarEls, true);
    togglePromotionProgressBar(notQualifiedEls, true);
    togglePromotionProgressBar(qualifiedEls, false);
    return false;
  } else {
    togglePromotionProgressBar(progressBarEls, false, true);
    togglePromotionProgressBar(notQualifiedEls, false, true);
    togglePromotionProgressBar(qualifiedEls, true, true, '0.5s');
    return true;
  }
}

function handleGWPPromotion(cart, subtotalClean, cartItemCount, freeShippingQualified, country) {
  const gwpEl = document.getElementById('gwp-threshold');
  const gwpSection = document.querySelectorAll('.cart-notification-free-gwp');
  if (!gwpEl || gwpSection.length === 0) return;
    gwpSection.forEach(el => el.style.display = 'flex');

  const freeShippingEl = document.querySelector('.cart-notification-promotion-free-shipping');
  const freeShippingIsActive = !!freeShippingEl;
  const freeShippingIsQualified = !!freeShippingQualified;

  // if free ship enabled, hide gwp progress bar
  const blockGWP = freeShippingIsActive && !freeShippingIsQualified;
  if (blockGWP) {
    gwpSection.forEach(el => {
      el.style.display = 'none';
    });
    return;
  }

  const gwpThreshold = parseFloat(gwpEl.dataset.gwpThreshold || 0);
  const gwpItemThreshold = parseInt(gwpEl.dataset.gwpItemThreshold || '0', 10);

  const useItemCount = gwpItemThreshold > 0;
  const remaining = useItemCount
    ? Math.max(gwpItemThreshold - cartItemCount, 0)
    : Math.max(gwpThreshold - subtotalClean, 0);

  const percent = useItemCount
    ? (cartItemCount / gwpItemThreshold) * 100
    : (subtotalClean / gwpThreshold) * 100;

  // Display GWP section
  gwpSection.forEach(el => el.style.display = 'flex');

  const gwpSpendMoreEls = document.querySelectorAll('.gwp-spend-more');
  const gwpPercentageEls = document.querySelectorAll('.gwp-percentage');
  const gwpQualified = percent >= 100;
  const gwpProgressBar = document.querySelectorAll('.gwp-progress-bar');
  const gwpNotQualified = document.querySelectorAll('.gwp-not-qualified');
  const gwpQualifiedMsg = document.querySelectorAll('.gwp-qualified');
  const gwpWrapper = document.querySelectorAll('.gwp-product-wrapper');

  const formattedRemaining = useItemCount ? remaining.toString() : formatCurrencyAmount(remaining, country);
  gwpSpendMoreEls.forEach(el => el.textContent = formattedRemaining);
  gwpPercentageEls.forEach(el => el.style.width = `${percent}%`);

  const gwpProductId = document.getElementById('gwp-product-id')?.dataset?.gwpProductid;
  const itemInCart = gwpProductId ? cart.items.find(item => item.id == gwpProductId) : false;

  if (!gwpQualified) {
    togglePromotionProgressBar(gwpProgressBar, true);
    togglePromotionProgressBar(gwpNotQualified, true);
    togglePromotionProgressBar(gwpQualifiedMsg, false);
    gwpSection.forEach(el => el.style.justifyContent = 'unset');
  } else if (!itemInCart) {
    gwpWrapper.forEach(el => {
      el.style.opacity = '1';
      el.style.transition = 'opacity 1s ease-in-out';
      el.style.transitionDelay = '0.5s';
    });

    // short-term animation
    setTimeout(() => {
      gwpProgressBar.forEach(el => el.style.display = 'none');
    }, 500);

    const wrapperEl = gwpWrapper[0];
    if (wrapperEl && typeof wrapperEl.style.opacity !== 'undefined') {
      wrapperEl.addEventListener('transitionend', () => {
        gwpSection.forEach(el => el.style.justifyContent = 'center');
        gwpProgressBar.forEach(el => el.style.height = '0');
      }, { once: true });

      wrapperEl.style.opacity = '0';
    }

    togglePromotionProgressBar(gwpProgressBar, false, true);
    togglePromotionProgressBar(gwpNotQualified, false, true);
    togglePromotionProgressBar(gwpQualifiedMsg, true, true, '0.5s');
  } else {
    togglePromotionProgressBar(gwpProgressBar, false);
    togglePromotionProgressBar(gwpNotQualified, false);
    togglePromotionProgressBar(gwpQualifiedMsg, true);
    gwpSection.forEach(el => el.style.justifyContent = 'center');
  }
}

function getNonSampleItemCount(cart) {
  return cart.items.reduce((sum, item) => {
    const isSample = String(item.properties?._freesample ?? '').toLowerCase() === 'true';
    return isSample ? sum : sum + Number(item.quantity || 0);
  }, 0);
}

window.calculatePromotions = async function () {
  const country = getCountryFromLocale();

  try {
    const res = await fetch(`/cart.js?country=${country}`);
    const cart = await res.json();
    const subtotalCents = cart.total_price;
    const giftCardTotalCents = cart.items.reduce((total, item) => item.gift_card === true ? total + (item.final_line_price || 0) : total, 0);
    const subtotalClean = (subtotalCents - giftCardTotalCents) / 100;
    const cartItemCount = getNonSampleItemCount(cart);

    if (!cart || cart.items.length === 0 || subtotalCents === 0) {
      document.querySelectorAll('.cart-notification-promotion').forEach(el => {
        el.style.display = 'none';
      });
      return;
    }

    document.querySelectorAll('.cart-notification-promotion').forEach(el => { el.style.display = 'block'; });
    document.querySelectorAll('.cart-total').forEach(el => { el.setAttribute('cartTotal', subtotalClean); });

    const freeShippingQualified = handleFreeShippingPromotion(subtotalClean, country);
    handleGWPPromotion(cart, subtotalClean, cartItemCount, freeShippingQualified, country);
    window.updateSampleButtons?.();

  } catch (error) {
    console.error("Error fetching cart or processing promotions:", error);
  }
};

document.addEventListener('cartdrawer:open', window.calculatePromotions);

window.fetchGraphQLData = async (query, variables) => {
  try {
    const response = await fetch(`https://${Shopify.shop}/api/2025-04/graphql.json`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Shopify-Storefront-Access-Token': window.STOREFRONT_API_KEY,
      },
      body: JSON.stringify({ query, variables }),
    });
    const { data, errors } = await response.json();
    if (errors) throw new Error(errors.map(e => e.message).join(', '));
    return data;
  } catch (e) {
    console.error('Error fetching data:', e);
    return null;
  }
};

// add props to products with promo messaging tags
window.getPromoLineItemProperties = (selectors, { mode = 'labels' } = {}) => {
  if (typeof selectors === 'string') selectors = [selectors];

  let attr;
  for (const selector of selectors) {
    attr = document.querySelector(selector);
    if (attr) break;
  }
  if (!attr) return {};

  const excluded  = attr.dataset.excludedFromPromotions === 'true';
  const finalSale = attr.dataset.finalSale === 'true';

  const props = {};
  if (mode === 'labels') {
    if (excluded)  props[window.promoMessaging.exclusionsApply] = window.promoMessaging.noPromos;
    if (finalSale) props[window.promoMessaging.finalSale]       = window.promoMessaging.noExchangesOrReturns;
  } else if (mode === 'flags') {
    if (excluded)  props._promo_exclusions = 'true';
    if (finalSale) props._promo_final_sale = 'true';
  }
  return props;
};


window.addToCartBySku = (sku, context = null, fromKit = false) => {
  const config = fetchConfig('javascript');
  config.headers['X-Requested-With'] = 'XMLHttpRequest';

  const responseSections = [
    'cart-icon-bubble',
    'cart-drawer',
  ];

  // Get properties based on context
  let promoProperties;
  if (context === 'sticky') {
    promoProperties = window.getPromoLineItemProperties(['.sticky-bar-atb']);
  } else if (context === 'pair-with') {
    promoProperties = window.getPromoLineItemProperties(['.product__upsell variant-selects']);
  } else {
    promoProperties = window.getPromoLineItemProperties([
      '#Quickshop-Modal product-info[data-view-context="Quickview"]',
      'cart-drawer.active #mini-cart-recommendations .recommended-product'
    ]);
  }

  const contextProperties = {
    _source: context ?? 'unknown'
  };

  const properties = {
    ...promoProperties,
    ...contextProperties,
  };

  config.body = JSON.stringify({
    id: sku,
    properties,
    sections: responseSections.join(',')
  })

  return fetch(`${window.routes.cart_add_url}`, config)
    .then((response) => response.json())
    .then((response) => {
      if (response.status) {
        const messageName = window.PUB_SUB_EVENTS ? window.PUB_SUB_EVENTS.cartError : 'cart-error';
        window.publish(messageName, {
          source: 'product-form',
          productVariantId: sku,
          errors: response.errors || response.description,
          message: response.message,
        });
      }

      const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');

       if (response.sections) {
          cart.renderContents(response, fromKit);
        } else {
          // Fallback: fetch cart.js then fetch sections
          fetchCartSections(['cart-drawer', 'cart-icon-bubble'])
            .then(sections => {
              // add the sections to the response
              response.sections = sections;
              cart.renderContents(response, fromKit);
            });
        }

      window.updateSampleButtons();
    })
    .catch((e) => {
      console.error(e);
    })
}

 function fetchCartSections(sections = ['cart-drawer', 'cart-icon-bubble']) {
    return fetch(window.Shopify.routes.root + '/cart.js')
      .then(res => res.json())
      .then(cart => {
        const params = new URLSearchParams();
        params.append('sections', sections.join(','));
        return fetch(`${window.Shopify.routes.root}?${params.toString()}`)
          .then(res => res.json());
      });
}

window.addToCartBundle = async (cta, selector) => {
  cta.classList.add('loading');
  const cartElem = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
  const productInfoWrapper =
    document.querySelector(`${selector} .product__info-wrapper`) ||
    document.querySelector(selector) ||
    document;
  const bundleKey = `bundle_${new Date().getTime()}`;
  const bundleProductID = document.querySelector(`${selector} product-info`)?.getAttribute('data-product-id'); // 'Bundle Product ID';
  const bundleName = document.querySelector(`${selector} product-info`)?.getAttribute('data-product-name'); //'Bundle Name';
  const bundleProductHandles = productInfoWrapper.querySelector(`input[name="bundle_product_handles"]`)?.value; //'All the bundle handles';
  
  const bundleImage = document.querySelector(`${selector} input[name="bundle_image"]`)?.value; // 'Bundle Image URL';
  const bundleShade = document.querySelector(`${selector} input[name="bundle_shade"]`)?.value;
  const bundleSize = document.querySelector(`${selector} input[name="bundle_size"]`)?.value;
  
  const bundleHandle = document.querySelector(`${selector} input[name="bundle_handle"]`)?.value; // 'Bundle Handle';
  const bundleChecks = document.querySelectorAll(`${selector} input.bundle-swatch:checked`);
  const parentVariant = document.querySelector(`${selector} .product-variant-id`)?.value;
  const bundleSku = document.querySelector(`${selector} input[name="bundle_sku"]`)?.value;
  const bundleProdId = document.querySelector(`${selector} input[name="bundle_product_id"]`)?.value;
  const form = document.querySelector(`${selector} form`);

  const promoFlags = window.getPromoLineItemProperties(
    ['#Quickshop-Modal product-info[data-view-context="Quickview"]'],
    { mode: 'flags' }
  );
  
  try {
    const prices = await window.fetchBundlePrices(bundleProdId);
    if (!prices || Object.keys(prices).length === 0) {
      throw new Error('Bundle pricing data unavailable');
    }
    window.bundlePrices = prices;

    const bundleIdsArray = Array.from(bundleChecks).map(cb => cb.getAttribute('bundle-variant-id'));
    const bundleData = {
      data: {
        items: bundleIdsArray.map(id => ({
          id,
          quantity: 1,
          properties: {
            _bundle_key: bundleKey,
            _bundle_name: bundleName,
            _bundle_product_handles: bundleProductHandles,
            _bundle_image: bundleImage,
            _bundle_product_id: bundleProductID,
            _bundle_handle: bundleHandle,
            _bundle_shade: bundleShade,
            _bundle_size: bundleSize,
            _parent_id: parentVariant,
            _bundle_sku: bundleSku,
            _bundle_price: JSON.stringify(prices),
            ...promoFlags
          }
        })),
        sections: cartElem
          ? cartElem.getSectionsToRender().map(s => s.id)
          : []
      }
    };

    if (cta.textContent.trim() === window.variantStrings.joinTheWaitlist) {
      document.getElementById('Waitlist-Modal-product').show();
      cta.removeAttribute('aria-disabled');
      return;
    }

    const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
      method:  'POST',
      headers: bundleIdsArray.length
        ? { 'Content-Type': 'application/json' }
        : config.headers,
      body: bundleIdsArray.length
        ? JSON.stringify(bundleData.data)
        : config.body
    });
    const payload = await response.json();
    if (payload.status) {
      form.handleErrorMessage(payload.description);
      throw payload;
    }
  
    if (payload.sections) {
        cartElem.renderContents(payload);
    } else {
      // Fallback: fetch cart.js then fetch sections
      fetchCartSections(['cart-drawer', 'cart-icon-bubble'])
        .then(sections => {
          // add the sections to the response
          payload.sections = sections;
          cartElem.renderContents(payload);
        });
    }

  } catch (err) {
    console.error('Bundle add to cart failed:', err);
    alert('Something went wrong. Please try reloading and adding to cart again.');
    // prevent bundle from being added
    return;
  } finally {
    cta.classList.remove('loading');
    if (!this.error) cta.removeAttribute('aria-disabled');
    if (cartElem?.classList.contains('is-empty')) cartElem.classList.remove('is-empty');
  }
};

function getLocaleConfigs(withFallback = false) {
  const tag = document.getElementById('locale-configs');
  let localeConfigs = [];
  if (tag) {
    try {
      const parsed = JSON.parse(tag.textContent.trim());
      localeConfigs = Array.isArray(parsed?.localeConfigs) ? parsed.localeConfigs : [];
    } catch (e) {
      console.error('Error parsing locale-configs JSON', e);
    }
  }
  if (withFallback && (!Array.isArray(localeConfigs) || localeConfigs.length === 0)) {
    console.warn('No localeConfigs found. Falling back to default US/en-US.');
    return [{ country: 'US', language: 'en-US' }];
  }
  return localeConfigs || [];
}

function makePriceQuery({countryEnum, languageEnum, mode}) {
  if ( mode === 'bundle') {
    return `
      query fetchCompanionProducts($ids: [ID!]!) 
      @inContext(country: ${countryEnum}, language: ${languageEnum}) {
        nodes(ids: $ids) {
          ... on Product {
            priceRange {
              maxVariantPrice { amount }
            }
          }
        }
      }
    `;
  }

  return `
    query fetchProductPrice($id: ID!)
    @inContext(country: ${countryEnum}, language: ${languageEnum}) {
      node(id: $id) {
        __typename
        ... on Product {
          priceRange {
            minVariantPrice { amount }
            maxVariantPrice { amount }
          }
        }
        ... on ProductVariant {
          product {
            priceRange {
              minVariantPrice { amount }
              maxVariantPrice { amount }
            }
          }
        }
      }
    }
  `;
}

window.fetchPrices = async ({productId, which = 'min', mode, allowFallbackLocales}) => {
  const isProduct = mode === 'product';
  const localeConfigs = getLocaleConfigs(allowFallbackLocales);
  const selector = which === 'max' ? 'maxVariantPrice' : 'minVariantPrice';
  const fetchedPrices = {};

  const promises = localeConfigs.map(async ({ country, language }) => {
    const countryEnum  = country.toUpperCase();
    const languageEnum = language.split('-')[0].toUpperCase();
    const query = makePriceQuery({countryEnum, languageEnum, mode});
    const productLookup = `gid://shopify/Product/${productId}`;
    const variantLookup = `gid://shopify/ProductVariant/${productId}`;

    if (isProduct) {
      try {
      const data = await window.fetchGraphQLData(query, { id: productLookup});
      const priceData = data?.node?.priceRange?.[selector];

      if (!priceData) throw new Error('No price data found');

      const amt = parseFloat(priceData.amount).toFixed(2);
      fetchedPrices[`_price-${countryEnum}`] = amt;
    } catch (err) {
      try  {
        const data = await window.fetchGraphQLData(query, { id: variantLookup });
        const priceData = data?.node?.product?.priceRange?.[selector];

        if (!priceData) throw new Error('No price data found');

        const amt = parseFloat(priceData.amount).toFixed(2);
        fetchedPrices[`_price-${countryEnum}`] = amt;
      } catch (err) {
        console.warn(`Failed to fetch product price for ${countryEnum}:`, err);
      }
    }
    } else {
      try {
        const data = await window.fetchGraphQLData(query, { ids: productLookup });
        const amt  = parseFloat(data.nodes[0].priceRange.maxVariantPrice.amount).toFixed(2);
        fetchedPrices[`_bundle_price-${countryEnum}`] = amt;
      } catch (err) {
        console.warn(`Failed to fetch price for ${countryEnum}:`, err);
      }
    }
  });

  await Promise.all(promises);
  if (Object.keys(fetchedPrices).length === 0) {
    throw new Error('No prices retrieved');
  }
  return fetchedPrices;
}

window.fetchProductPrices = function(productId, { which = 'min' } = {}) {
  return fetchPrices({
    mode: 'product',
    productId,
    which,
    allowFallbackLocales: true
  });
};

window.fetchBundlePrices = async function(productId, { which = 'max' } = {}) {
  // reset window.bundlePrices. In case it fails, it should not have previous value
  window.bundlePrices = null;
  return fetchPrices({
    mode: 'bundle',
    which,
    productId,
    allowFallbackLocales: false
  });
};

// const DETAILS_ID = 'Details-FreeSamples';
const DETAILS_IDS = [
  'Details-FreeSamples',
  'Details-BagSpecialsRecommendations'
];

function preserveAccordion(fn) {
  const openTabs = DETAILS_IDS
    .map(id => {
      const el = document.getElementById(id);
      return el && el.open ? id : null;
    })
    .filter(Boolean);

  return Promise.resolve(fn()).then(json => {
    openTabs.forEach(id => {
      const el = document.getElementById(id);
      if (el) el.open = true;
    });
    return json;
  });
}

 window.updateSampleButtons = function() {
  fetch(window.routes.cart_url + '.js')
    .then(r => r.json())
    .then(cart => {
      const sampleItems = cart.items.filter(item =>
        item.properties['_freesample'] === 'true'
      );
      const selectedCount = sampleItems.length;
      const wrapper = document.querySelector('.general-samples-swiper .swiper-wrapper');
      const limit = wrapper
        ? parseInt(wrapper.dataset.maxLimit, 10)
        : 0;

      document.querySelectorAll('.sample-select-button').forEach(btn => {
        const sku = Number(btn.dataset.variantId);
        const inCart = sampleItems.some(item => item.variant_id === sku);

        if (inCart) {
          btn.textContent = 'Remove';
          btn.classList.add('selected');
          btn.disabled = false;
        } else if (selectedCount >= limit) {
          btn.textContent = 'Select';
          btn.classList.remove('selected');
          btn.disabled = true;
        } else {
          btn.textContent = 'Select';
          btn.classList.remove('selected');
          btn.disabled = false;
        }
      });
    });
}

document.addEventListener('DOMContentLoaded', window.updateSampleButtons);

window.selectFreeSample = async function (newSku) {
  const buttons = document.querySelectorAll('.sample-select-button');
  buttons.forEach(btn => {
    btn.classList.add('is-processing');
    btn.disabled = true;
  });

  try {
    const cart = await fetch(window.routes.cart_url + '.js').then(res => res.json());
    const currentSample = cart.items.find(item =>
      item.properties?.['_freesample'] === 'true'
    );

    if (currentSample && currentSample.variant_id !== Number(newSku)) {
      await window.removeFreeSample(currentSample.variant_id);
      await waitForSampleRemoval(currentSample.variant_id);
    }

    await window.addToCartFreeSample(newSku);
  } catch (err) {
    console.error('Error swapping sample:', err);
  } finally {
    buttons.forEach(btn => btn.classList.remove('is-processing'));
    window.updateSampleButtons();
  }
};

// Wait until the sample is actually removed from the cart
async function waitForSampleRemoval(sku, maxAttempts = 5) {
  for (let attempt = 0; attempt < maxAttempts; attempt++) {
    const cart = await fetch(window.routes.cart_url + '.js').then(res => res.json());
    const stillThere = cart.items.find(item =>
      item.properties?.['_freesample'] === 'true' && item.variant_id === Number(sku)
    );

    if (!stillThere) return;
    await new Promise(res => setTimeout(res, 300));
  }
}

window.addToCartFreeSample = async function(sku) {
  return preserveAccordion(async () => {
    const config = fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    config.body = JSON.stringify({
      id: sku,
      quantity: 1,
      properties: { _freesample: 'true' },
      sections: 'cart-icon-bubble,cart-drawer'
    });
    const country = getCountryFromLocale();
    const url = `${window.routes.cart_add_url}?country=${encodeURIComponent(country)}`;
    const json = await fetch(url, config).then(r => r.json());
    const cartEl = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    cartEl.renderContents(json);
    window.initFreeSamplesSwiper(document.querySelector('.general-samples-swiper.swiper'));
    window.updateSampleButtons();

    return json;
  });
};

window.removeFreeSample = async function(sku) {
  return preserveAccordion(async () => {
    // find the line index
    const cart = await fetch(window.routes.cart_url + '.js').then(r => r.json());
    const idx = cart.items.findIndex(item =>
      item.variant_id === Number(sku) &&
      item.properties['_freesample'] === 'true'
    );
    if (idx === -1) return;

    const config = fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    config.body = JSON.stringify({
      line: idx + 1,
      quantity: 0,
      sections: 'cart-icon-bubble,cart-drawer'
    });
    const country = getCountryFromLocale();
    const url = `${window.routes.cart_change_url}?country=${encodeURIComponent(country)}`;
    const json = await fetch(url, config).then(r => r.json());
    const cartEl = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    cartEl.renderContents(json);
    window.initFreeSamplesSwiper(document.querySelector('.general-samples-swiper.swiper'));
    window.updateSampleButtons();

    return json;
  });
};

document.addEventListener('click', (e) => {
  const btn = e.target.closest('.sample-select-button');
  if (!btn) return;

  e.preventDefault();
  const sku = btn.dataset.variantId;

  if (btn.classList.contains('selected')) {
    window.removeFreeSample(sku).then(() => {
      window.updateSampleButtons();
    });
  } else {
    window.selectFreeSample(sku);
  }

});

window.initFreeSamplesSwiper = function(container) {
  if (!container || container.classList.contains('swiper-initialized')) return;
  new Swiper(container, {
    slidesPerView: 2,
    slidesPerGroup: 2,
    loop: false,
    navigation: {
      nextEl: container.querySelector('.free-sample-button-next'),
      prevEl: container.querySelector('.free-sample-button-prev'),
    },
    scrollbar: {
      el: container.querySelector('.swiper-scrollbar'),
      draggable: true,
    },
    breakpoints: {
      767: {
        slidesPerView: 2,
        slidesPerGroup: 2,
      },
    },
  });
};

window.initNewsletter = function(){
  const url = new URL(window.location.href);
  if (url.searchParams.has('customer_posted')) {
    window.history.replaceState({}, document.title, url.pathname);
  }

  const wrapper = document.querySelector('.newsletter-form');
  const emailInput = wrapper.querySelector("input[type='email']");

  const toggleConsent = () => {
    if (emailInput === document.activeElement || emailInput.value.trim() !== '') {
      wrapper.classList.add('show-consent');
    } else {
      wrapper.classList.remove('show-consent');
    }
  };

  emailInput.addEventListener('focus', toggleConsent);
  emailInput.addEventListener('input', toggleConsent);

  const consentCheckbox = document.querySelector("input[name='consent']");

  if (consentCheckbox) {
    consentCheckbox.addEventListener('invalid', function (e) {
      e.target.setCustomValidity('Please accept terms and conditions listed.');
    });

    consentCheckbox.addEventListener('input', function (e) {
      e.target.setCustomValidity('');
    });
  }

  const submitButton = emailInput?.form?.querySelector('.newsletter-submit');
  const errorMsg = wrapper.querySelector('.field__error-message');

  const isValidEmail = (email) => {
    return /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(email);
  };

  emailInput?.addEventListener('blur', function () {
    const email = emailInput.value.trim();
    if (isValidEmail(email)) {
      submitButton.disabled = false;
      errorMsg.classList.add('hidden');
      emailInput.classList.remove('error');
      errorMsg.style.display = 'none;'
    } else {
      submitButton.disabled = true;
      if (email.length > 0) {
        errorMsg.classList.remove('hidden');
        emailInput.classList.add('error');
        errorMsg.style.display = 'block';
      } else {
        errorMsg.style.display = 'none;'
        emailInput.classList.remove('error');
      }
    }
  });
}

document.addEventListener('DOMContentLoaded', window.initNewsletter);


// Capture hash before Shopify scripts can remove it
if (window.location.hash === '#reviews') {
  sessionStorage.setItem('scrollToReviews', 'true');
}

document.addEventListener('DOMContentLoaded', () => {
  const shouldScroll = sessionStorage.getItem('scrollToReviews') === 'true';

  if (!shouldScroll) return;

  const scrollToReviews = () => {
    const target = document.querySelector('#yotpo-reviews-main-widget');
    if (target && target.offsetHeight > 0) {
      sessionStorage.removeItem('scrollToReviews');
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    } else {
      setTimeout(scrollToReviews, 300);
    }
  };

  scrollToReviews();
});


// Capture hash before Shopify scripts can remove it
if (window.location.hash === '#reviews') {
  sessionStorage.setItem('scrollToReviews', 'true');
}

document.addEventListener('DOMContentLoaded', () => {
  const shouldScroll = sessionStorage.getItem('scrollToReviews') === 'true';

  if (!shouldScroll) return;

  const scrollToReviews = () => {
    const target = document.querySelector('#yotpo-reviews-main-widget');
    if (target && target.offsetHeight > 0) {
      sessionStorage.removeItem('scrollToReviews');
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    } else {
      setTimeout(scrollToReviews, 300);
    }
  };

  scrollToReviews();
});

document.addEventListener('click', async (e) => {
  const btn = e.target.closest('.recommended-cta-button');
  let fromKit = false;
  if (btn?.classList?.contains('kit-special')) {
    fromKit = true
  }
  if (!btn || !btn.classList.contains('add')) return;

  const variantId = btn.dataset.variantId;
  if (!variantId) {
    console.log('No variant selected');
    return;
  }

  btn.setAttribute('aria-disabled', 'true');
  const productContainer = e.target.parentElement;
  const shouldBlock = await window.preventAddIfMaxedOut(variantId, productContainer);
  if (shouldBlock) return;

  window.addToCartBySku(variantId, 'recommended', fromKit);
});

document.addEventListener('DOMContentLoaded', () => {
  const signInSource = sessionStorage.getItem('signInSource');
  const params = new URLSearchParams(window.location.search);
  const shouldReopenCart = params.get('cart') === 'open';
  const isLoggedIn = window.Shopify?.customer || document.body.classList.contains('customer-logged-in');

  const openCart = () => {
    const cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer?.show) {
      cartDrawer.show();
    } else {
      document.querySelector('.mini-bag-button, [data-modal="#Cart-Modal"], [data-cart-trigger]')?.click();
    }
  };

  document.querySelectorAll('[data-account-register]').forEach(link => {
    link.addEventListener('click', () => {
      sessionStorage.setItem('signInSource', 'cart');
    });
  });

  const returnToInput = document.querySelector('input[name="return_to"]');
  if (returnToInput && signInSource === 'cart') {
    const url = new URL(returnToInput.value, window.location.origin);
    url.searchParams.set('cart', 'open');
    returnToInput.value = url.pathname + url.search;
  }

  if (shouldReopenCart && isLoggedIn) {
    openCart();
  }

  if (shouldReopenCart) {
    params.delete('cart');
    const cleanUrl = window.location.pathname + (params.toString() ? `?${params.toString()}` : '');
    window.history.replaceState({}, document.title, cleanUrl);
  }

  sessionStorage.removeItem('signInSource');
});

// consent settings footer link
document.addEventListener('click', (e) => {
  const link = e.target.closest('a');
  if (!link) return;

  const url = new URL(link.href, window.location.origin);
  const isMenuItem  = link.matches('.list-menu__item--consent-settings a');
  const isHrefExact = url.pathname === '/' && url.searchParams.has('consent-settings');
  const hasParam    = url.searchParams.has('consent-settings');

  if (isMenuItem || isHrefExact || hasParam) {
    e.preventDefault();
    Optanon.ToggleInfoDisplay();
  }
});

document.addEventListener('DOMContentLoaded', function () {
  const isLoggedIn = window.customerIsLoggedIn;
  const lastState = localStorage.getItem('customerState');
  const currentState = isLoggedIn ? 'logged_in' : 'logged_out';

  if (lastState !== currentState) {
    localStorage.setItem('customerState', currentState);
    if (isLoggedIn) {
      document.dispatchEvent(new CustomEvent('customer:loggedin'));
    }

    fetch(window.routes.cart_url + '.js')
    .then(r => r.json())
    .then(cart => {
      const sampleItems = cart.items.filter(item =>
        item.properties['_freesample'] === 'true'
      );

      if (sampleItems.length === 0) return;

      sampleItems.forEach(item => {
        window.removeFreeSample(item.variant_id);
      });
    });
  }
});

window.getRenderedCartSections = function(sections = ['cart-drawer', 'cart-icon-bubble']) {
 const root = window.Shopify.routes?.root || '';
  const localePrefix = root.endsWith('/') ? root.slice(0, -1) : root;

  const params = new URLSearchParams();
  params.append('sections', sections.join(','));

  return fetch(`${localePrefix}/?${params.toString()}`, {
    headers: {
      'X-Requested-With': 'XMLHttpRequest'
    }
  }).then(res => {
    if (!res.ok) throw new Error(`Sections request failed: ${res.status}`);
    return res.json();
  });
}

document.addEventListener('customer:loggedin', () => {
  const config = fetchConfig('javascript');
  config.headers['X-Requested-With'] = 'XMLHttpRequest';

  const responseSections = [
    'cart-icon-bubble',
    'cart-drawer',
  ];

  config.body = JSON.stringify({
    sections: responseSections.join(',')
  })

  fetch(window.routes.cart_url + '.js', config)
    .then(r => r.json())
    .then(cart => {
      const cartEl = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      window.getRenderedCartSections()
        .then((sections) => {
          cartEl?.renderContents({ sections }, false, false);
        })
        .catch((err) => {
          console.error('Failed to refresh cart drawer:', err);
        });
    })
});

document.addEventListener('DOMContentLoaded', function () {
  const hash = window.location.hash;

  if (hash) {
    const targetElement = document.querySelector(hash);

    if (targetElement) {
      const elementTop = targetElement.getBoundingClientRect().top + window.pageYOffset;
      const offset = 150;
      window.scrollTo({
        top: elementTop - offset,
        behavior: 'smooth'
      });
    }
  }
});

window.getVariantQuantityInCart = async function (variantId) {
  try {
    const cart = await fetch('/cart.js').then((res) => res.json());
    return cart.items.reduce((sum, item) => {
      return item.variant_id === Number(variantId) ? sum + item.quantity : sum;
    }, 0);
  } catch (err) {
    console.error('[Cart] Failed to fetch cart data:', err);
    return 0;
  }
};

const SHOP_DEFAULT_MAX = window.shopDefaultMaxQuantity;
const BUNDLE_DEFAULT_MAX = window.shopDefaultBundleMaxQuantity;

window.showQuantityLimitModal = function (shadeName, maxQuantity) {
  const modal = document.querySelector('#QuantityLimitReached');
  if (!modal) return;

  const product = modal.querySelector('#MaxedOutProductName');
  if (product) product.textContent = shadeName || 'this product';

  const quantityLimit = modal.querySelector('#MaxQuantity');
  if (quantityLimit) quantityLimit.textContent = `to ${maxQuantity}`;

  modal.show();
};

function getProductAndVariantMetafieldsData(containerEl, selectedVariant) {
  const metafieldsData = containerEl.querySelector('[data-product-variant-metafields-json]');

  if (!metafieldsData) {
    console.warn('Metafields script not found.');
    return null;
  }

  try {
    const parsed = JSON.parse(metafieldsData.textContent);
    const productMetafields = parsed.product || {};
    const variantMetafields = parsed.variants || {};
    const variantData = variantMetafields[selectedVariant] || {};

    const isValidQuantity = (val) => {
      return typeof val !== 'boolean'
        && val !== ''
        && val !== 'null'
        && val != null
        && !isNaN(Number(val))
        && Number(val) > 0;
    };

    let maxQuantity;

    if (isValidQuantity(variantData?.max_quantity)) {
      maxQuantity = variantData.max_quantity;
    } else if (isValidQuantity(productMetafields.metafields?.max_quantity)) {
      maxQuantity = productMetafields.metafields.max_quantity;
    } else {
      // use defaults
      if (productMetafields.metafields?.bundle_set_handles && BUNDLE_DEFAULT_MAX) {
        maxQuantity = BUNDLE_DEFAULT_MAX;
      } else {
        maxQuantity = isValidQuantity(SHOP_DEFAULT_MAX) ? SHOP_DEFAULT_MAX : 6;
      }
    }

    const maxQuantityNumber = Number(maxQuantity);
    return { maxQuantityNumber, productTitle: productMetafields.title, variantShade: variantData.title || '' };
  } catch (err) {
    console.error('Failed to parse metafields JSON:', err);
    return null;
  }
}

window.preventAddIfMaxedOut = async (variantId, containerEl) => {
  if (!variantId || !containerEl) {
    // failed because function was called but param not set correctly, do not prevent atb on error
    return false;
  }
  const metafields = getProductAndVariantMetafieldsData(containerEl, variantId);
    if ( !metafields) {
    // failed because metafields were not availabe, do not prevent atb on error
    return false;
  }
  const currentQty = await window.getVariantQuantityInCart(variantId);
  const maxQty = metafields?.maxQuantityNumber ?? SHOP_DEFAULT_MAX;
  const productTitle = `${metafields.productTitle} - ${metafields.variantShade}`;

  if (currentQty >= maxQty) {
    window.showQuantityLimitModal(productTitle, maxQty);
    return true;
  }

  return false;
};


let swiperInitialized = false;

function initPopTartesSwiper() {
  const swiperEl = document.querySelector('.pop-tartes-swiper');
  if (!swiperEl || swiperInitialized) return;

  const drawerVisible = document.querySelector('.menu-drawer')?.offsetParent !== null;
  if (!drawerVisible) return;

  const slides = swiperEl.querySelectorAll('.swiper-slide');
  const nextBtn = swiperEl.querySelector('.swiper-button-next');
  const prevBtn = swiperEl.querySelector('.swiper-button-prev');

  const totalSlides = slides.length;
  
  prevBtn.style.display = 'none';

  if (totalSlides <= 1) {
    nextBtn.style.display = 'none';
    prevBtn.style.display = 'none';
    return;
  }

  const swiper = new Swiper(swiperEl, {
    slidesPerView: 3.5,
    slidesPerGroup: 1,
    spaceBetween: 12,
    grabCursor: true,
    loop: false,
    navigation: {
      nextEl: nextBtn,
      prevEl: prevBtn,
    },
    observer: true,
    observeParents: true,
    observeSlideChildren: true,
    threshold: 10,
  });

  swiper.update();

  nextBtn.style.display = '';

  swiperInitialized = true;

  nextBtn.addEventListener('click', function () {
    if (prevBtn.style.display === 'none' || getComputedStyle(prevBtn).display === 'none') {
      prevBtn.style.display = 'flex';
    }
  });
}

document.querySelector('#Details-menu-drawer-container')?.addEventListener('toggle', (e) => {
  if (e.target.open) {
    requestAnimationFrame(() => {
      initPopTartesSwiper();
    });
  }
});

function parseDisplayPrice(rawText) {
  if (!rawText) return NaN;
  const cleaned = rawText.replace(/[^\d.,]/g, '');

  // Remove leading/trailing dots or commas that aren't part of a number
  const trimmed = cleaned.replace(/^[.,]+|[.,]+$/g, '');

  if (!trimmed) return NaN;

  const lastComma = trimmed.lastIndexOf(',');
  const lastDot = trimmed.lastIndexOf('.');
  let normalized = trimmed;

  // normalize currencies with decimals and commas
  if (lastComma !== -1 && lastDot !== -1) {
    const decimalIsComma = lastComma > lastDot;
    if (decimalIsComma) {
      normalized = trimmed.replace(/\./g, '').replace(/,/g, '.');
    } else {
      normalized = trimmed.replace(/,/g, '');
    }
  } else if (lastComma !== -1) {
    const parts = trimmed.split(',');
    const tail = parts[parts.length - 1];
    if (/^\d{2}$/.test(tail)) {
      normalized = trimmed.replace(/,/g, '.');
    } else {
      normalized = trimmed.replace(/,/g, '');
    }
  } else {
    normalized = trimmed;
  }

  const val = parseFloat(normalized);
  return Number.isFinite(val) ? val : NaN;
}

function formatStrikethroughPrice(el) {
  const rawText = el.textContent.trim();
  if (!rawText) return;

  const val = parseDisplayPrice(rawText);
  if (!Number.isFinite(val)) return;

  const currency =
    (window.Shopify && Shopify.currency && Shopify.currency.active) ||
    document.documentElement.getAttribute('data-shopify-currency') ||
    'USD';


  const locale =
    (window.Shopify && Shopify.locale) ||
    document.documentElement.lang ||
    navigator.language ||
    'en-US';

  const base = new Intl.NumberFormat(locale, { style: 'currency', currencyDisplay: 'narrowSymbol', currency });
  const { maximumFractionDigits, locale: resolvedLocale } = base.resolvedOptions();

  const isWhole = Math.round(val * 100) % 100 === 0;
  const minFD = isWhole ? 0 : Math.min(2, maximumFractionDigits ?? 2);
  const maxFD = maximumFractionDigits ?? 2;

  const formatter = new Intl.NumberFormat(resolvedLocale, {
    style: 'currency',
    currencyDisplay: 'narrowSymbol',
    currency,
    minimumFractionDigits: minFD,
    maximumFractionDigits: maxFD,
  });

  el.textContent = formatter.format(val);
}


function watchAndFormatStrikethroughPrices() {
  const strikeEls = document.querySelectorAll('.price__container .price-item');
  if (!strikeEls.length) return;

  strikeEls.forEach((el) => {
    let debounceTimer = null;
    let attempts = 0;
    const maxAttempts = 5;

    const observer = new MutationObserver(() => {
      if (debounceTimer) clearTimeout(debounceTimer);

      debounceTimer = setTimeout(() => {
        attempts++;
        formatStrikethroughPrice(el);

        if (attempts >= maxAttempts) {
          observer.disconnect();
        }
      }, 150);
    });

    observer.observe(el, {
      characterData: true,
      subtree: true,
      childList: true,
    });

    formatStrikethroughPrice(el);
  });

  document.dispatchEvent(new CustomEvent('priceFormatted:regios'));
}

// Handle clicks on elements with data-open-signin-modal attribute
document.addEventListener('click', function(e) {
  const target = e.target;
  if (target && target.hasAttribute('data-open-signin-modal')) {
    e.preventDefault();
    const modal = document.querySelector('#SignIn-Modal');
    if (modal) modal.show();
  }
});

// Handle clicks on elements with data-open-signin-modal attribute
document.addEventListener('click', function(e) {
  const target = e.target;
  if (target && target.hasAttribute('data-open-signin-modal')) {
    e.preventDefault();
    const modal = document.querySelector('#SignIn-Modal');
    if (modal) modal.show();
  }
});

window.reduceShadesPDP = (container) => {
  const rootEl = container || document;
  const productInfo = rootEl.querySelector('product-info');
  const productInfoParent = productInfo.parentElement;

  const isPDPView = productInfoParent.classList.contains('product-section') || productInfoParent.classList.contains('quickshop-modal');
  if (isPDPView) {
    const reducedShades = productInfo.querySelectorAll('[data-reduced-shades="pdp"] .swiper-slide[data-include-reduced="false"]')
    reducedShades.forEach((shade) => {
      shade.remove();
    })
  }
}